import React from 'react'
import Header from '../../Home/Header'
import Footer from '../../Home/Footer';
import AboutCareer from '../About/AboutCareer'
import AboutCareer2 from '../About/AboutCareer2'
const Career = () => {
  return (
    <>
    <Header/>
    <AboutCareer />
    <AboutCareer2 />
    <Footer />
    </>
)
}

export default Career